import { observer } from 'mobx-react-lite'
import { CallHistoryHeader } from 'pages/conversations/pages/calls/ui/CallHistory/ui/web/CallHistoryHeader/CallHistoryHeader'
import { EmptyStateCallHistory } from 'pages/conversations/pages/calls/ui/CallHistory/ui/EmptyStateCallHistory/EmptyStateCallHistory'
import styles from '../styles.module.scss'

export const WebEmptyStateCallHistory = observer(() => {
  return (
    <div className={styles.wrap}>
      <CallHistoryHeader isShowSearch={false} />
      <EmptyStateCallHistory />
    </div>
  )
})
